import {
  DataField,
  DataField_KindDataEnum,
} from '@skedulo/protobuf-web/dist/query/api/v1/api'
import { IDataSchema } from '../../core/api'

export interface NunjucksTemplateContext {
  lookup: (name: string) => unknown
}

export function enumLabel(
  this: NunjucksTemplateContext,
  value: string,
  path: string,
) {
  const dataSchema: IDataSchema = this.lookup('$dataSchema') as IDataSchema
  if (!dataSchema) return null
  return (
    path
      .split('.')
      .reduce(
        (
          acc: {
            fields: DataField[]
            enum: DataField_KindDataEnum | undefined
          },
          current: string,
        ) => {
          const field = acc.fields.find((field) => field.name === current)
          return {
            fields: field?.relatedObject?.schema?.fields ?? [],
            enum: field?.enum,
          }
        },
        { fields: dataSchema.fields, enum: undefined },
      )
      .enum?.values?.find((enumValue) => {
        return enumValue.stringValue === value
      })?.label ?? value
  )
}
